import {
  BondScreenerViewNameModal,
} from '@/creditflowresearch/ui/common/components/molecules/BondScreenerViewNameModal';

interface IBondScreenerRenameViewModalProps {
  isVisible: boolean,
  existingNames: string[],
  initialName: string,
  onRename: (name: string) => void,
  onCancel: () => void,
}

const BondScreenerRenameViewModal = ({
  isVisible,
  existingNames,
  initialName,
  onRename,
  onCancel,
}: IBondScreenerRenameViewModalProps) => (
  <BondScreenerViewNameModal
    isVisible={ isVisible }
    title="Rename View"
    submitLabel="Save"
    dataTest="bondScreenerRenameViewModal"
    existingNames={ existingNames }
    initialName={ initialName }
    onSubmit={ onRename }
    onCancel={ onCancel }
  />
);

export default BondScreenerRenameViewModal;
